export default __webpack_public_path__ + "static/media/47SD5_47VE6.f2bc02dd.png";